import { createLogic } from 'redux-logic';
import { AUTH_TOKEN_KEY } from 'config/constants';
import * as localStore from 'lib/localStore';
import setSBAAuthenticationCookie from 'lib/setSBAAuthenticationCookie';
import * as sbaActions from '../sba/actions';

const sbaAuthenticationRemove = createLogic({
  type: sbaActions.removeSBAAuthentication,
  process() {
    localStore.remove(AUTH_TOKEN_KEY);
    setSBAAuthenticationCookie();
  },
});

export default sbaAuthenticationRemove;
